var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-list" },
    [
      _c("booking-header-details", {
        on: {
          edit: function ($event) {
            return _vm.$emit("edit-query", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.isMultiRoomBookingEnabled
        ? _c(
            "div",
            { staticClass: "multibooking-sidebar-wrapper" },
            [
              _c(
                "transition",
                { attrs: { name: "slide-right" } },
                [
                  _vm.isActive
                    ? _c("multi-booking-sidebar", {
                        ref: "multiBookingSidebar",
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.isActive
                  ? _c("div", {
                      staticClass: "backlight",
                      on: { click: _vm.closeSidebar },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("simple-list", {
        ref: "list",
        attrs: {
          "server-items": _vm.roomsAvailable,
          variant: "booking-room-list",
          query: "roomType",
          "undefined-value": _vm.tc("booking.all"),
        },
        scopedSlots: _vm._u([
          {
            key: "errors",
            fn: function () {
              return [
                _vm.lastQuery && !_vm.loadingRooms && _vm.errorTypeCode
                  ? _c(
                      "div",
                      [
                        _vm.errorTypeCode === "noResultsError"
                          ? [
                              _c(
                                "div",
                                {
                                  key: "no-results-error",
                                  staticClass: "error-box",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.tc(
                                            "errors.checkAvailability.noAvailabilityError.firstLine"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "no-icon",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.noAvailabilityErrorSecondLine
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "no-icon" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.tc(
                                            "errors.checkAvailability.noAvailabilityError.thirdLine"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  key: "general-error",
                                  staticClass: "error-box",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.tc(
                                            "errors.checkAvailability.genericError.firstLine"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "no-icon",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.genericErrorSecondLine
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.areDatesAndGuestsEmpty && !_vm.loadingRooms
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          key: "no-date-error",
                          staticClass: "error-box no-date",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.tc("errors.dateMissingError.firstLine")
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "no-icon" }, [
                            _c(
                              "a",
                              {
                                staticClass: "error-cta",
                                attrs: { href: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCalendar($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.tc("errors.dateMissingError.ctaLabel")
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "filter",
            fn: function (ref) {
              var filters = ref.filters
              return [
                _vm.roomsAvailable.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "filter",
                        attrs: { "data-component": "booking-room-filters" },
                      },
                      [
                        _c("accessible-tabs", [
                          _c(
                            "div",
                            {
                              staticClass: "filter-items",
                              attrs: { role: "tablist" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "filter-item tab-group-button",
                                  class: [{ active: !_vm.roomTypeFilter }],
                                  attrs: {
                                    id: "room-filter-all",
                                    role: "tab",
                                    "aria-selected": !_vm.roomTypeFilter,
                                    "aria-controls": _vm.tc("booking.all"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.filterRoomType($event)
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "right",
                                            39,
                                            $event.key,
                                            ["Right", "ArrowRight"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 2
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterRoomType(
                                          $event,
                                          _vm.roomTypes[0]
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "left",
                                            37,
                                            $event.key,
                                            ["Left", "ArrowLeft"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 0
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterRoomType(
                                          $event,
                                          _vm.hasAccessibleRooms
                                            ? "accessible"
                                            : _vm.roomTypes[
                                                _vm.roomTypes.length - 1
                                              ]
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.tc("booking.all")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.roomTypes, function (roomType, i) {
                                return _c(
                                  "button",
                                  {
                                    key: roomType,
                                    staticClass: "filter-item tab-group-button",
                                    class: [
                                      {
                                        active: _vm.roomTypeFilter === roomType,
                                        disabled:
                                          _vm.roomTypeIsDisabled(roomType),
                                      },
                                    ],
                                    attrs: {
                                      id: "room-filter-" + i,
                                      role: "tab",
                                      "aria-selected":
                                        _vm.roomTypeFilter === roomType,
                                      "aria-controls": roomType,
                                      tabindex:
                                        _vm.roomTypeFilter === roomType &&
                                        !_vm.roomTypeIsDisabled(roomType)
                                          ? "0"
                                          : "-1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.filterRoomType(
                                          $event,
                                          roomType
                                        )
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "right",
                                              39,
                                              $event.key,
                                              ["Right", "ArrowRight"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 2
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterRoomType(
                                            $event,
                                            i === _vm.roomTypes.length - 1
                                              ? _vm.hasAccessibleRooms
                                                ? "accessible"
                                                : null
                                              : _vm.roomTypes[i + 1]
                                          )
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "left",
                                              37,
                                              $event.key,
                                              ["Left", "ArrowLeft"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 0
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterRoomType(
                                            $event,
                                            i === 0
                                              ? null
                                              : _vm.roomTypes[i - 1]
                                          )
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(roomType) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.hasAccessibleRooms
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "filter-item tab-group-button",
                                      class: [
                                        {
                                          active:
                                            _vm.roomTypeFilter === "accessible",
                                          disabled:
                                            _vm.roomTypeIsDisabled(
                                              "accessible"
                                            ),
                                        },
                                      ],
                                      attrs: {
                                        id: "room-filter-accessible",
                                        role: "tab",
                                        "aria-selected":
                                          _vm.roomTypeFilter === "accessible",
                                        tabindex:
                                          _vm.roomTypeFilter === "accessible" &&
                                          !_vm.roomTypeIsDisabled("accessible")
                                            ? "0"
                                            : "-1",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.filterRoomType(
                                            $event,
                                            "accessible"
                                          )
                                        },
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "right",
                                                39,
                                                $event.key,
                                                ["Right", "ArrowRight"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 2
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.filterRoomType(
                                              $event,
                                              null
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "left",
                                                37,
                                                $event.key,
                                                ["Left", "ArrowLeft"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 0
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.filterRoomType(
                                              $event,
                                              _vm.roomTypes[
                                                _vm.roomTypes.length - 1
                                              ]
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.tc(
                                              "accessibility.accessibility"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.showRoomFilter
                          ? _c("room-filter", {
                              ref: "roomFilter",
                              attrs: {
                                rooms: _vm.roomsAvailable,
                                "room-type-filter": filters,
                                "has-accessible-rooms": _vm.hasAccessibleRooms,
                                "accessible-selected":
                                  _vm.roomTypeFilter === "accessible",
                              },
                              on: {
                                updateFilteredRooms: _vm.updateRoomsAvailable,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var activate = ref.activate
                                      var isActive = ref.isActive
                                      var resetAllFilters = ref.resetAllFilters
                                      var totalFiltersSelected =
                                        ref.totalFiltersSelected
                                      return _c(
                                        "button",
                                        {
                                          staticClass: "room-filter--activator",
                                          class: totalFiltersSelected
                                            ? "filter-selected"
                                            : "",
                                          on: { click: activate },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "room-filter--activator-label",
                                              class: totalFiltersSelected
                                                ? "filter-selected"
                                                : "",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.tc("booking.filter"))
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          totalFiltersSelected > 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "room-filter--activator-total-tag",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(totalFiltersSelected)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "icon-filter-black",
                                          }),
                                          _vm._v(" "),
                                          totalFiltersSelected > 0
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "room-filter--activator-reset",
                                                  attrs: {
                                                    tabindex: isActive
                                                      ? "-1"
                                                      : "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return resetAllFilters(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        _vm.tc("booking.reset")
                                                      ) +
                                                      "\n            "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "banner",
            fn: function () {
              return [
                _vm.isBookingEditMode && !_vm.loadingRooms && _vm.bookingReady
                  ? _c(
                      "div",
                      [
                        _c("modify-edit-banner", {
                          attrs: { "is-room-list": true },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "no-items",
            fn: function () {
              return [
                _vm.lastQuery && _vm.bookingReady
                  ? _c(
                      "div",
                      {
                        key: "general-error",
                        staticClass: "error-box no-margin",
                        attrs: { role: "alert" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.tc(
                                  "errors.checkAvailability.genericError.firstLine"
                                )
                              ) +
                              "\n          "
                          ),
                          _vm.$refs.roomFilter
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "room-filter--activator-reset no-margin",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.$refs.roomFilter.resetAllFilters(
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.tc("booking.reset")) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "rendered-list",
            fn: function (ref) {
              var items = ref.items
              return [
                _c(
                  "ul",
                  _vm._l(items, function (item) {
                    return _c(
                      "li",
                      { key: item.id },
                      [
                        _c("room-card", {
                          attrs: { room: item, filter: _vm.roomTypeFilter },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }